import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import SideContact from './components/SideContact';
import SideSocial from './components/SideSocial';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import ProjectsPage from './pages/ProjectsPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import './App.css';
import './Theme.css';
import './ContactPageStyle.css';

function App() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        // Preloader effect
        setTimeout(() => {
            setIsLoaded(true);
        }, 100);
    }, []);

    return (
        <HelmetProvider>
            <Router>
                <ScrollToTop />
                <div className="App" style={{ opacity: isLoaded ? 1 : 0, transition: 'opacity 0.5s ease' }}>
                    <SideContact />
                    <SideSocial />
                    <Navbar />

                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projects" element={<ProjectsPage />} />
                        <Route path="/services" element={<ServicesPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                    </Routes>

                    <Footer />
                </div>
            </Router>
        </HelmetProvider>
    );
}

export default App;
